var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginForms',{model:{value:(_vm.activeForm),callback:function ($$v) {_vm.activeForm=$$v},expression:"activeForm"}})}
var staticRenderFns = []

export { render, staticRenderFns }